import * as yup from "yup";

export const CantidadSchema = yup
  .object()
  .shape({
    magnitud: yup.number(),
    unidad: yup.object(),
  })
  .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
    return value?.magnitud >= 0;
  })
  .test(
    "magnitud.required",
    "errors.cantidad.magnitud.required",
    (value, context) => {
      return (!!value && value?.magnitud !== undefined) || !value;
    },
  )
  .test(
    "unidad.required",
    "errors.cantidad.unidad.required",
    (value, context) => {
      return (!!value && value?.unidad !== undefined) || !value;
    },
  );
